<template>
  <div class="done-invoice-index">
    <header>
      <div>
        <MainButton
          size="mini"
          :handleClick="() => handleBtnClick('select')"
        >
          <span>筛选</span>
        </MainButton>
      </div>
      <div class="search">
        <van-search :value="query.purchaserName" placeholder="请输入搜索关键词" :clearable="false"
          @input="(e) => setQuery({ field: 'purchaserName', value: e })"
        />
      </div>
      <div>
        <MainButton
          size="mini"
          :handleClick="() => handleBtnClick('query')"
        >
          <span>搜索</span>
        </MainButton>
      </div>
    </header>
    <main>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-swipe-cell v-for="invoice in tableData" :key="invoice.id">
            <section class="card" @click="handleBtnClick('getInfo', invoice)">
              <div class="content">
                <div>
                  <h6 class="text-hide">{{ invoice.purchaserName }}</h6>
                  <div class="row">
                    <div>开票日期</div>
                    <div class="text-hide">{{ getData(invoice.drewDate) }}</div>
                  </div>
                  <div class="row">
                    <div>开票类型</div>
                    <div v-if="invoice.billingType === 1" class="abnormal-invoice text-hide">负数发票</div>
                    <div v-else class="normal-invoice text-hide">正数发票</div>
                  </div>
                  <div class="row">
                    <div>价税合计</div>
                    <div class="text-hide">{{ Number(invoice.amountWithTax).toFixed(2) }}</div>
                  </div>
                </div>
                <div>
                  <img class="invoice-img" :src="getInvoiceImgOrName('url', invoice.invoiceType)" alt="发票类型" />
                </div>
              </div>
            </section>
            <template #right>
              <div class="right-btn">
                <div>
                  <!-- :disabled="getRedBtnDisabled(invoice)" -->
                  <MainButton
                    :type="'danger'"
                    :handleClick="() => handleBtnClick('redInvoice', invoice)"
                  >
                    <span>红冲</span>
                  </MainButton>
                </div>
                <div>
                  <MainButton
                    :handleClick="() => handleBtnClick('download', invoice)"
                  >
                    <span>下载</span>
                  </MainButton>
                </div>
                <div>
                  <MainButton
                    type="warning"
                    :handleClick="() => handleBtnClick('sendMail', invoice)"
                  >
                    <span>邮箱/短信</span>
                  </MainButton>
                </div>
              </div>
            </template>
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
      <!-- 下载 -->
      <van-overlay class-name="download-pop" :show="showDownload" @click="showDownload = false">
        <div v-if="popType === 'download'" class="wrapper" @click.stop>
          <div v-if="selectedItem.pdfUrl">
            <span>PDF地址</span>
            <span @click="handleDown('pdfUrl')">下载</span>
          </div>
          <div v-if="selectedItem.ofdUrl">
            <span>OFD地址</span>
            <span @click="handleDown('ofdUrl')">下载</span>
          </div>
          <div v-if="selectedItem.xmlUrl">
            <span>XML地址</span>
            <span @click="handleDown('xmlUrl')">下载</span>
          </div>
        </div>
        <div v-if="popType === 'sendMail'" class="wrapper" @click.stop>
          <van-field v-model="sendInfo.mailAddress" label="邮箱地址" placeholder="请输入" />
          <van-field v-model="sendInfo.purchaserPhone" label="手机号码" placeholder="请输入" />
          <div>
            <MainButton
              :handleClick="() => handleBtnClick('sendEmail')"
            >
              <span>确认发送</span>
            </MainButton>
          </div>
        </div>
      </van-overlay>
      <van-popup v-model="popShow" round position="bottom" :style="{ height: '50%' }">
        <div class="pop">
          <div class="select-invoice">
            <select class="invoice-select" @change="handleChangeInvoiceType">
              <option v-for="item in actions" :key="item.value" :value="item.value" :selected="invoiceType === item.value">{{ item.text }}</option>
            </select>
            <!-- <i class="allIconFont">&#xe6d0;</i> -->
          </div>
          <div class="dates">
            <div>
              <van-datetime-picker
                @change="handleDateChange"
                :show-toolbar="false"
                :value="startDate"
                :max-date="maxDate"
                type="date"
                title="选择年月日"
              >
                <template #default>
                  <div></div>
                </template>
              </van-datetime-picker>
            </div>
            <div class="segmentation"><span>至</span></div>
            <div>
              <van-datetime-picker
                @change="handleDateChange($event, 'endDate')"
                :show-toolbar="false"
                :max-date="maxDate"
                :value="endDate"
                type="date"
                title="选择年月日"
              >
                <template #default>
                  <div></div>
                </template>
              </van-datetime-picker>
            </div>
          </div>
          <footer>
            <div>
              <MainButton
                :handleClick="() => handleBtnClick('confirmQuery')"
              >
                <span>确认</span>
              </MainButton>
            </div>
            <div>
              <MainButton
                type="default"
                :handleClick="() => handleBtnClick('cancelQuery')"
              >
                <span>取消</span>
              </MainButton>
            </div>
          </footer>
        </div>
      </van-popup>
    </main>
  </div>
</template>

<script>
import { INVOICE_TYPE_IMG_AND_NAME_MAP } from '@/assets/config.js'
import MainButton from '@/components/MainButton/index.vue'
import moment from 'moment'
import Observer from '@utils/observer'
import { download, isSpecialTicket, isAllElectric, aesDoEncrypt } from '@utils/basicUtil'
import { List, Field, Overlay, PullRefresh, Notify, Popover, SwipeCell, Search, Popup, Calendar, Picker, Checkbox, CheckboxGroup, DatetimePicker } from 'vant'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    MainButton,
    [DatetimePicker.name]: DatetimePicker,
    [SwipeCell.name]: SwipeCell,
    [Field.name]: Field,
    [Overlay.name]: Overlay,
    [Popover.name]: Popover,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [List.name]: List,
    [Calendar.name]: Calendar,
    [Checkbox.name]: Checkbox,
    [PullRefresh.name]: PullRefresh,
    [CheckboxGroup.name]: CheckboxGroup
  },
  computed: {
    ...mapState('doneInvoiceListModel', ['tableData', 'query', 'total']),
    getInvoiceImgOrName () {
      return (type, invoiceType) => {
        let data = ''
        if (INVOICE_TYPE_IMG_AND_NAME_MAP.find(i => i.value === invoiceType)) {
          data = INVOICE_TYPE_IMG_AND_NAME_MAP.find(i => i.value === invoiceType)[type]
        } else {
          data = '全部发票种类'
        }
        return data
      }
    },
    getData () {
      return (time) => {
        return moment(time).format('YYYY-MM-DD')
      }
    },
    getRedBtnDisabled () {
      return (invoice) => {
        if (isSpecialTicket(invoice.invoiceType) || isAllElectric(invoice.invoiceType)) {
          return true
        }
        if (invoice.billingType === 1 || invoice.invoiceStatus === 20 || invoice.invoiceStatus === 21) {
          return true
        }
        return false
      }
    }
  },
  data () {
    return {
      sendInfo: {
        mailAddress: '',
        purchaserPhone: '',
        invoiceIds: [],
        defaultSend: 0,
        source: 2
      },
      showSelectInvoiceType: false,
      loading: false,
      finished: false,
      showDownload: false,
      startDate: new Date(moment().startOf('month').format('YYYY/M/D')),
      endDate: new Date(moment().endOf('month').format('YYYY/M/D')),
      refreshing: false,
      popShow: false,
      popType: '',
      maxDate: new Date(),
      actions: [
        { text: '电子普票', value: 3, className: 'type-actions' },
        { text: '电子专票', value: 4, className: 'type-actions' },
        { text: '数电普票', value: 7, className: 'type-actions' },
        { text: '数电专票', value: 8, className: 'type-actions' },
        { text: '全部发票种类', value: '', className: 'type-actions' }],
      invoiceType: '',
      selectedItem: {}
    }
  },

  async mounted () {
  },
  async activated () {
    await this.initTableData()
    this.onRefresh()
    Observer.setFunction({
      type: 'changeCompany',
      fn: this.companyChangeRefresh
    })
  },
  methods: {
    ...mapActions('doneInvoiceListModel', ['getTableData', 'sendEmailAndPhone', 'getInvoiceInfoById']),
    ...mapMutations('doneInvoiceListModel', ['setLoading', 'setQuery', 'initTableData']),
    handleChangeInvoiceType (e) {
      this.invoiceType = e.target.value
    },
    async handleDown (type) {
      Notify({ type: 'success', message: '正在下载...' })
      download({
        url: this.selectedItem[type],
        title: this.selectedItem.invoiceNo
      })
      this.showDownload = false
    },
    handleDateChange (e, type) {
      if (type === 'endDate') {
        this.endDate = e.getValues().join('/')
      } else {
        this.startDate = e.getValues().join('/')
      }
    },
    async handleBtnClick (type, row) {
      if (type === 'select') {
        // 每次点筛选的时候需要把query中的值赋值到data中
        this.startDate = this.query.startDate
        this.endDate = this.query.endDate
        this.invoiceType = this.query.invoiceType
        this.popShow = true
      }
      if (type === 'query') {
        await this.initTableData()
        this.onRefresh()
      }
      if (type === 'cancelQuery') {
        this.popShow = false
      }
      if (type === 'confirmQuery') {
        this.setQuery({ field: 'startDate', value: this.startDate })
        this.setQuery({ field: 'endDate', value: this.endDate })
        this.setQuery({ field: 'invoiceType', value: this.invoiceType })
        this.popShow = false
        this.handleBtnClick('query')
      }
      if (type === 'download') {
        this.popType = type
        this.selectedItem = row
        this.showDownload = true
      }
      if (type === 'sendMail') {
        this.popType = type
        this.sendInfo.invoiceIds = [row.id]
        this.sendInfo.mailAddress = row.purchaserEmail
        this.sendInfo.purchaserPhone = row.purchaserPhone
        this.selectedItem = row
        this.showDownload = true
      }
      if (type === 'sendEmail') {
        const flag = await this.sendEmailAndPhone(this.sendInfo)
        if (flag) return
        await this.initTableData()
        this.onRefresh()
        this.showDownload = false
      }
      if (type === 'getInfo') {
        this.$router.push(`/invoice-list/info?id=${row.id}`)
      }
      if (type === 'redInvoice') {
        if (isSpecialTicket(row.invoiceType) || isAllElectric(row.invoiceType)) {
          Notify({ type: 'danger', message: '红冲暂不支持专票和数电票！' })
          return
        }
        if (row.billingType === 1 || row.invoiceStatus === 20 || row.invoiceStatus === 21) {
          Notify({ type: 'danger', message: '红冲发票无法红冲！' })
          return
        }
        this.$router.push(`/invoice-red/index?key=${aesDoEncrypt({
          invoiceNo: row.invoiceNo,
          invoiceCode: row.invoiceCode
        })}`)
      }
    },
    async onLoad () {
      if (this.refreshing) {
        await this.initTableData()
        this.refreshing = false
      }
      await this.setQuery({ field: 'current', value: Number(this.query.current) + 1 })
      // 重置查询条件
      await this.getTableData()
      this.loading = false
      if (this.tableData.length >= Number(this.total)) {
        this.finished = true
      }
    },
    async onRefresh () {
      await this.setQuery({ field: 'current', value: 0 })
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    async companyChangeRefresh () {
      if (window.location.pathname + window.location.search === '/invoice-list/index') {
        await this.initTableData()
        this.onRefresh()
      }
    }
  }
}
</script>

<style lang="less" scoped src="./style.less" />
